import type { GroupOrderResponse } from "../../../entities/group-order/model/types";

export interface GroupMember {
  line_id: string;
  representative_id?: string | null;
  display_name: string;
  line_name?: string | null;
  representative_name?: string | null;
  phone_number?: string | null;
  role: "customer" | "seller";
  status?: string;
}

export interface SellerGroup {
  id: string;
  name: string;
}

export interface Group {
  id: string;
  name: string;
  waitSeconds: number;
  status: boolean;
  memberCount: number;
  groupSellerId?: string | null;
  groupSellerName?: string | null;
  createdAt?: string;
  updatedAt?: string;
  members: GroupMember[];
}

export const buildGroupListRequestKey = (
  page: number,
  pageSize: number,
  search: string,
): string => JSON.stringify([page, pageSize, search.trim()]);

export const formatRepresentativeId = (
  representativeId?: string | null,
): string | null => {
  const normalizedId = representativeId?.trim();
  if (!normalizedId) {
    return null;
  }

  const [mtCode, ...branchParts] = normalizedId.split("-");
  const branchCode = branchParts.join("-").trim();
  return branchCode ? `${mtCode} - ${branchCode}` : mtCode;
};

export const getGroupMemberIdentifier = (
  member: Pick<GroupMember, "line_id" | "representative_id" | "role">,
): string => {
  if (member.role === "customer") {
    return formatRepresentativeId(member.representative_id) || member.line_id;
  }
  return member.line_id;
};

export const toGroup = (item: GroupOrderResponse): Group => ({
  id: item.group_id,
  name: item.group_name,
  waitSeconds: item.waiting_time,
  status: !item.delete_at,
  memberCount: item.member_count,
  groupSellerId: item.group_sale_id,
  groupSellerName: item.group_sale_name,
  createdAt: item.created_at,
  updatedAt: item.updated_at,
  members: item.members.map((member) => ({
    line_id: member.line_id,
    representative_id: member.representative_id,
    display_name:
      member.representative_name || member.line_name || member.line_id,
    line_name: member.line_name,
    representative_name: member.representative_name,
    phone_number: member.phone_number,
    role: member.role,
    status: member.status,
  })),
});
